<template>
  <div class="relative ">
    <label class="absolute z-10 top-0 left-0 text-xs ml-2 text-black -translate-y-50 bg-white px-1 leading-none cursor-pointer">{{ label }}</label>
    <select
      v-model="selectedValue"
      class="form-input pr-8 lg:pr-10"
      @change="handleChange"
    >
      <option
        disabled
        value=""
      >
        {{ defaultOption ? defaultOption : $t('message.dropdown.defaultOption') }}
      </option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :disabled="option.disabled"
      >
        {{ option.label }}
      </option>
    </select>
    <div class="absolute top-50 right-0 mr-2 -translate-y-50 pointer-events-none   lg:mr-3">
      <vue-feather type="chevron-down" class="w-4 h-4 block" />
    </div>
  </div>
</template>

<script>
import VueFeather from 'vue-feather';

/**
 * dropdown.vue
 */
export default {
  components: {
    VueFeather
  },

  props: {
    label: {
      type: String,
      required: true,
    },

    options: {
      type: Array,
      required: true,
      validator: (options) => {
        return options.filter(option => option.label && option.value).length >= 1
      },
    },

    defaultOption: {
      type: String,
      default: ''
    },

    selected: {
      type: String,
      default: '',
    },
  },

  emits: ['changeEvent'],

  data () {
    return {
      selectedValue: '',
    }
  },

  watch: {
    selected: function (newVal, oldVal) {
      this.selectedValue = newVal
    },
  },

  mounted () {
    this.selectedValue = this.selected
  },

  methods: {
    handleChange () {
      this.$emit('changeEvent', this.options.findIndex(option => this.selectedValue === option.value))
    },
  },
}
</script>
